"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var Tooltip_1 = tslib_1.__importDefault(require("../Tooltip"));
var InfoTooltip = function (_a) {
    var content = _a.content, _b = _a.size, size = _b === void 0 ? 'm' : _b, color = _a.color;
    return (react_1.default.createElement(Tooltip_1.default, { content: content },
        react_1.default.createElement(Icon_1.default, { name: "tooltip", size: size, color: color })));
};
exports.default = InfoTooltip;
